"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gbfc = exports.Catalogue = exports.State = exports.Telemetry = exports.LatestTelemetryUpdate = exports.SensorIdentifier = exports.NAMESPACE = exports.Prefs = exports.SupportedPrefs = exports.FactorySerialNumber = exports.Sku = void 0;
const effect_1 = require("effect");
const cellular_1 = require("../../../../network/cellular");
const schema_1 = require("../../../../schema");
const capability_1 = require("../../capability");
const vendor_1 = require("../../vendor");
const _util_1 = require("../_util");
const Base = __importStar(require("../base"));
const failure_mode_1 = require("./failure-mode");
const Prefs = __importStar(require("./prefs"));
exports.Sku = __importStar(require("./sku"));
exports.FactorySerialNumber = __importStar(require("./factory-serial-number"));
exports.SupportedPrefs = __importStar(require("./supported-prefs"));
exports.Prefs = __importStar(require("./prefs"));
exports.NAMESPACE = 'Culligan.Device.Class.Gbfc';
const operatingModes = [
    'Standard',
    'Disabled',
    'Factory',
    'Fault',
    'Ota',
    'Service',
    'Installation',
];
const powerProfiles = ['Standard', 'Eco', 'Sleep'];
const logLevels = ['Silent'];
const connectivity = [
    'Cellular',
    'CellularVPN',
    'Wi-Fi',
    'Off',
];
const Connectivity = Base.makeConnectivity(exports.NAMESPACE, connectivity);
const slots = [
    [capability_1.Consumable.Definition.CulliganGlobalFilter.CulliganGlobalFilter],
    [capability_1.Consumable.Definition.CulliganGlobalFilter.CulliganGlobalFilter],
    [capability_1.Consumable.Definition.CulliganGlobalFilter.CulliganGlobalFilter],
    [capability_1.Consumable.Definition.CulliganGlobalFilter.CulliganGlobalFilter],
    [capability_1.Consumable.Definition.CO2Tank.CO2Tank],
];
const alarms = {
    consumableBased: [capability_1.Alarm.ConsumableDepleted, capability_1.Alarm.ConsumableLowLevel, capability_1.Alarm.ConsumableOverused],
    firmwareBased: [
        capability_1.Alarm.ColdNTC,
        capability_1.Alarm.CompressorFault,
        capability_1.Alarm.CompressorTimeout,
        capability_1.Alarm.DryHeat,
        capability_1.Alarm.FirewallFault,
        capability_1.Alarm.HighTDS,
        capability_1.Alarm.HotTankFault,
        capability_1.Alarm.HotNTC,
        capability_1.Alarm.HotTankOh,
        capability_1.Alarm.HotTankTimeout,
        capability_1.Alarm.IceBathWaterLevelFault,
        capability_1.Alarm.IceBathIceThickness,
        capability_1.Alarm.LeakBottom,
        capability_1.Alarm.NWtr,
        capability_1.Alarm.TankUVCLedFault,
        capability_1.Alarm.DripFull,
    ],
    telemetryBased: [capability_1.Alarm.OutOfRange],
};
const commands = [...capability_1.Command.systemCommands];
const sensors = {
    ht_temp: capability_1.Telemetry.Sensor.Number({
        name: 'Hot tank temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 80, max: 98 }),
    }),
    ct_temp: capability_1.Telemetry.Sensor.Number({
        name: 'Cold tank temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 3, max: 9 }),
    }),
    tds_pre: capability_1.Telemetry.Sensor.Number({
        name: 'Inlet water TDS',
        type: capability_1.Telemetry.WaterTDS,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 1, max: 500 }),
    }),
    tds_post: capability_1.Telemetry.Sensor.Number({
        name: 'Post-treatment TDS',
        type: capability_1.Telemetry.WaterTDS,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 1, max: 500 }),
    }),
    tds_redux: capability_1.Telemetry.Sensor.Number({
        name: 'TDS reduction',
        type: capability_1.Telemetry.TdsReduction,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 0, max: 100 }),
    }),
    tot_s_po: capability_1.Telemetry.Sensor.Number({
        name: 'Total sparkling pourings',
        type: capability_1.Telemetry.TotalInteractions,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tot_ls_po: capability_1.Telemetry.Sensor.Number({
        name: 'Total lightly sparkling pourings',
        type: capability_1.Telemetry.TotalInteractions,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tot_a_po: capability_1.Telemetry.Sensor.Number({
        name: 'Total ambient pourings',
        type: capability_1.Telemetry.TotalInteractions,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tot_h_po: capability_1.Telemetry.Sensor.Number({
        name: 'Total hot pourings',
        type: capability_1.Telemetry.TotalInteractions,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tot_eh_po: capability_1.Telemetry.Sensor.Number({
        name: 'Total extra hot pourings',
        type: capability_1.Telemetry.TotalInteractions,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tot_c_po: capability_1.Telemetry.Sensor.Number({
        name: 'Total cold pourings',
        type: capability_1.Telemetry.TotalInteractions,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tot_int: capability_1.Telemetry.Sensor.Number({
        name: 'Total dispense interactions',
        type: capability_1.Telemetry.TotalInteractions,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ov_wd_fb_s: capability_1.Telemetry.Sensor.Number({
        name: 'Total sparkling water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ov_wd_fb_ls: capability_1.Telemetry.Sensor.Number({
        name: 'Total lightly sparkling water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ov_wd_fb_a: capability_1.Telemetry.Sensor.Number({
        name: 'Total ambient water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ov_wd_fb_h: capability_1.Telemetry.Sensor.Number({
        name: 'Total hot water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ov_wd_fb_eh: capability_1.Telemetry.Sensor.Number({
        name: 'Total extra hot water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ov_wd_fb_c: capability_1.Telemetry.Sensor.Number({
        name: 'Total cold water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ov_wd_fb: capability_1.Telemetry.Sensor.Number({
        name: 'Overall water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    drip_s: capability_1.Telemetry.Sensor.Boolean({
        name: 'Drip tray full',
        type: capability_1.Telemetry.DripTrayFull,
        expectedValue: capability_1.Telemetry.ExpectFalse,
    }),
    flowr_c: capability_1.Telemetry.Sensor.Number({
        name: 'Cold flow-rate',
        type: capability_1.Telemetry.FlowRate,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 0, max: 3 }),
    }),
    flowr_h: capability_1.Telemetry.Sensor.Number({
        name: 'Hot flow-rate',
        type: capability_1.Telemetry.FlowRate,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 0, max: 2 }),
    }),
    flowr_s: capability_1.Telemetry.Sensor.Number({
        name: 'Sparkling flow-rate',
        type: capability_1.Telemetry.FlowRate,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 0, max: 2 }),
    }),
    flowr_a: capability_1.Telemetry.Sensor.Number({
        name: 'Ambient flow-rate',
        type: capability_1.Telemetry.FlowRate,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 0, max: 2 }),
    }),
    flowr_r: capability_1.Telemetry.Sensor.Number({
        name: 'Refill flow-rate',
        type: capability_1.Telemetry.FlowRate,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    c_tmo: capability_1.Telemetry.Sensor.Number({
        name: 'Cold tank timeouts',
        type: capability_1.Telemetry.TotalTankTimeouts,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    h_tmo: capability_1.Telemetry.Sensor.Number({
        name: 'Hot tank timeouts',
        type: capability_1.Telemetry.TotalTankTimeouts,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    cm_cy: capability_1.Telemetry.Sensor.Number({
        name: 'Compressor cycles',
        type: capability_1.Telemetry.TotalCompressorCycles,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ht_cy: capability_1.Telemetry.Sensor.Number({
        name: 'Hot tank cycles',
        type: capability_1.Telemetry.TotalHotTankCycles,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ht_stat: capability_1.Telemetry.Sensor.Boolean({
        name: 'Hot tank operation permitted',
        type: capability_1.Telemetry.ComponentOperationPermitted,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    fw_stat: capability_1.Telemetry.Sensor.Boolean({
        name: 'Firewall operation permitted',
        type: capability_1.Telemetry.ComponentOperationPermitted,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    uvc_stat: capability_1.Telemetry.Sensor.Boolean({
        name: 'UVC operation permitted',
        type: capability_1.Telemetry.ComponentOperationPermitted,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    cm_stat: capability_1.Telemetry.Sensor.Boolean({
        name: 'Compressor operation permitted',
        type: capability_1.Telemetry.ComponentOperationPermitted,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    wt_pres: capability_1.Telemetry.Sensor.Number({
        name: 'Water pressure',
        type: capability_1.Telemetry.WaterPressure,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    fw_eff: capability_1.Telemetry.Sensor.Number({
        name: 'Firewall effectiveness',
        type: capability_1.Telemetry.FirewallEffectiveness,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
};
exports.SensorIdentifier = effect_1.Schema.Literal(...effect_1.Record.keys(sensors)).annotations({
    identifier: `${exports.NAMESPACE}.SensorIdentifier`,
});
exports.LatestTelemetryUpdate = effect_1.Schema.Record({ key: exports.SensorIdentifier, value: effect_1.Schema.DateFromNumber })
    .pipe(effect_1.Schema.partialWith({ exact: true }))
    .annotations({
    identifier: `${exports.NAMESPACE}.LatestTelemetryUpdate`,
});
const events = [capability_1.Event.DrinkDispensed, capability_1.Event.RadioSurvey];
exports.Telemetry = effect_1.Schema.Struct({
    ht_temp: capability_1.Telemetry.WaterTemperature.FromScalar,
    ct_temp: capability_1.Telemetry.WaterTemperature.FromScalar,
    tds_pre: capability_1.Telemetry.WaterTDS.FromScalar,
    tds_post: capability_1.Telemetry.WaterTDS.FromScalar,
    tds_redux: capability_1.Telemetry.TdsReduction.FromScalar,
    tot_s_po: capability_1.Telemetry.TotalInteractions.FromScalar,
    tot_ls_po: capability_1.Telemetry.TotalInteractions.FromScalar,
    tot_a_po: capability_1.Telemetry.TotalInteractions.FromScalar,
    tot_h_po: capability_1.Telemetry.TotalInteractions.FromScalar,
    tot_eh_po: capability_1.Telemetry.TotalInteractions.FromScalar,
    tot_c_po: capability_1.Telemetry.TotalInteractions.FromScalar,
    tot_int: capability_1.Telemetry.TotalInteractions.FromScalar,
    ov_wd_fb_s: capability_1.Telemetry.WaterDispensed.FromScalar,
    ov_wd_fb_ls: capability_1.Telemetry.WaterDispensed.FromScalar,
    ov_wd_fb_a: capability_1.Telemetry.WaterDispensed.FromScalar,
    ov_wd_fb_h: capability_1.Telemetry.WaterDispensed.FromScalar,
    ov_wd_fb_eh: capability_1.Telemetry.WaterDispensed.FromScalar,
    ov_wd_fb_c: capability_1.Telemetry.WaterDispensed.FromScalar,
    ov_wd_fb: capability_1.Telemetry.WaterDispensed.FromScalar,
    drip_s: capability_1.Telemetry.DripTrayFull.FromScalar,
    flowr_c: capability_1.Telemetry.FlowRate.FromScalar,
    flowr_h: capability_1.Telemetry.FlowRate.FromScalar,
    flowr_s: capability_1.Telemetry.FlowRate.FromScalar,
    flowr_a: capability_1.Telemetry.FlowRate.FromScalar,
    flowr_r: capability_1.Telemetry.FlowRate.FromScalar,
    c_tmo: capability_1.Telemetry.TotalTankTimeouts.FromScalar,
    h_tmo: capability_1.Telemetry.TotalTankTimeouts.FromScalar,
    cm_cy: capability_1.Telemetry.TotalCompressorCycles.FromScalar,
    ht_cy: capability_1.Telemetry.TotalHotTankCycles.FromScalar,
    ht_stat: capability_1.Telemetry.ComponentOperationPermitted.FromScalar,
    fw_stat: capability_1.Telemetry.ComponentOperationPermitted.FromScalar,
    fw_eff: capability_1.Telemetry.FirewallEffectiveness.FromScalar,
    cm_stat: capability_1.Telemetry.ComponentOperationPermitted.FromScalar,
    uvc_stat: capability_1.Telemetry.ComponentOperationPermitted.FromScalar,
    wt_pres: capability_1.Telemetry.WaterPressure.FromScalar,
}).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
});
exports.State = effect_1.Schema.Struct({
    ...Base.State.fields,
    operatingMode: effect_1.Schema.Literal(...operatingModes),
    powerProfile: effect_1.Schema.Literal(...powerProfiles),
    logLevel: effect_1.Schema.Literal(...logLevels),
    connectivity: effect_1.Schema.optionalWith(Connectivity, { exact: true }),
    iccid: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(cellular_1.Iccid), { exact: true }),
    location: effect_1.Schema.optionalWith(Base.NullableDetectedLocation, { exact: true }),
    cpsi: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    dsn: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    sku: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(schema_1.PrintString), { exact: true }),
    // `optionalWith` covers the field being absent (firmware does not emit it yet); `NullOr`
    // additionally accepts an explicit `null`, which a device sends to report that it has no
    // power board serial. Consumers treat both absent and `null` as "no value".
    powerBoardSerial: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(schema_1.PrintString), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.State`,
});
exports.Catalogue = (0, _util_1.makeCatalogue)(slots).annotations({
    identifier: `${exports.NAMESPACE}.Catalogue`,
});
const identifier = `${exports.NAMESPACE}.Gbfc`;
/**
 * @author Federico Lotta - Electronics Lead Engineer <federico.lotta@culligan.com>
 * @author Darren Bamber - Lead Engineer <darren.bamber@culligan.com>
 * @author Cameron King - Firmware Lead Developer <cameron.king@culligan.com>
 * @author Stefano Marchioro - Firmware Developer <smarchioro@sapra.com>
 */
class Gbfc extends effect_1.Schema.Class(identifier)({
    model: effect_1.Schema.tag('gbfc'),
    alarms: (0, _util_1.makeActiveAlarms)(alarms),
    consumables: (0, _util_1.makeSlottedConsumables)(slots),
    state: exports.State,
    latestTelemetry: effect_1.Schema.partialWith(exports.Telemetry, { exact: true }),
    latestTelemetryUpdate: effect_1.Schema.optionalWith(exports.LatestTelemetryUpdate, {
        exact: true,
        default: () => ({}),
    }),
    prefs: effect_1.Schema.optionalWith(Prefs.Prefs, { exact: true, default: () => Prefs.DEFAULT_PREFS }),
    vendor: vendor_1.Culligan.DeviceInfo,
    ...Base.CommonProps.fields,
}, { identifier }) {
    static code = 'gbfc';
    static label = 'Purity';
    static category = 'Dispenser';
    static operatingModes = operatingModes;
    static powerProfiles = powerProfiles;
    static logLevels = logLevels;
    static alarms = alarms;
    static slots = slots;
    static sensors = sensors;
    static events = events;
    static commands = commands;
    static connectivity = connectivity;
    static connectionGateway = 'TartabitBridge';
    static image = null;
    static State = exports.State;
    static Prefs = Prefs.Prefs;
    static SettablePrefs = Prefs.SettablePrefs;
    static PrefsFromPartial = Prefs.PrefsFromPartial;
    static Telemetry = exports.Telemetry;
    static Catalogue = exports.Catalogue;
    static vendors = [vendor_1.Culligan.code];
    static init = (props, dates) => {
        return new this(Base.deviceInitProps({
            operatingMode: 'Factory',
            powerProfile: 'Standard',
            logLevel: 'Silent',
            connectivity: 'Cellular',
        }, slots, null, props, dates));
    };
    get code() {
        return `${this.vendor.code}${this.model}`;
    }
    get consumableAlarms() {
        // Check all 4 filter slots (0-3)
        const filterAlarms = effect_1.Array.flatMapNullable([0, 1, 2, 3], slotNumber => {
            const consumable = this.consumables[slotNumber];
            return consumable && (0, _util_1.checkAlarmOnExpendableConsumable)(consumable, slotNumber);
        });
        // Check CO2 tank slot (4)
        const co2Alarm = (0, _util_1.checkAlarmOnDepletableConsumable)(this.consumables[4], 4);
        return [...filterAlarms, ...(co2Alarm ? [co2Alarm] : [])];
    }
    telemetryAlarms = [];
    get manufacturingInfo() {
        return effect_1.Option.none();
    }
    get failureModes() {
        return (0, failure_mode_1.getFailureModes)(this);
    }
}
exports.Gbfc = Gbfc;
//# sourceMappingURL=index.js.map